export const poolTableRoutes = [
    {
        path: "/poolTableList",
        name: "poolTableList",
        meta: {
            title: "球桌列表",
            key: 'pool-table-list',
            pageApisPrm: import("@/views/poolTableManage/poolTableList/Index.vue").then(({ pageApiList }: any) => pageApiList)
        },
        component: () => import("@/views/poolTableManage/poolTableList/Index.vue"),
    },
]